import React from "react";
import { faqs } from "./FaqsData";

const Faqs = () => {
  return (
    <div className="bg-light">
      <div className="container py-5 ">
        <div className="py-5">
          <h1 className="text-center mb-4 fs-2 prata-regular">
            Color Correction Faqs{" "}
          </h1>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            {faqs.map((val, index) => (
              <div className="accordion-item bg-transparent" key={index}>
                <h2 className="accordion-header" id={`flush-heading-${index}`}>
                  <button
                    className="accordion-button collapsed shadow-none bg-transparent fw-600"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-collapse-${index}`}
                    aria-expanded="false"
                    aria-controls={`flush-collapse-${index}`}
                  >
                    {val.question}
                  </button>
                </h2>
                <div
                  id={`flush-collapse-${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`flush-heading-${index}`}
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">{val.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
